module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJ5ZXMiPz4KPHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIGQ9Ik0wIDE0IEwxMDAgMCBMMTAwIDg2IEwwIDEwMCBaIiBmaWxsPSIjREFEQURCIiAvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/components/PageHeader/MauerBack/rhombus-tablet.svg
// module id = 434
// module chunks = 35783957827783